export default __webpack_public_path__ + "static/media/red-logout.b5ef36d0.svg";